import React, { useEffect, useState } from 'react';
import { createOrder, getCart, removeFromCart } from '../api';
import { useNavigate } from 'react-router-dom';
import './ShopPages.css';

function CartPage() {
    const token = localStorage.getItem('token');
    const [cartItems, setCartItems] = useState([]);
    const [message, setMessage] = useState('');
    const [isOrdering, setIsOrdering] = useState(false);
    const [removingItemId, setRemovingItemId] = useState(null);
    const navigate = useNavigate();

    const fetchCart = async () => {
        setMessage('');
        if (!token) {
            setMessage('Вы не авторизованы!');
            return;
        }
        const cartData = await getCart(token);
        if (cartData.items) {
            setCartItems(cartData.items);
        } else {
            setCartItems([]);
        }
    };

    useEffect(() => {
        fetchCart();
        // eslint-disable-next-line
    }, []);

    const handleRemove = async (itemId) => {
        if (removingItemId !== null) {
            return;
        }

        setMessage('');
        setRemovingItemId(itemId);

        try {
            const res = await removeFromCart(token, itemId);
            if (res.message === 'Item removed from cart') {
                setMessage('Товар удалён из корзины');
            } else {
                setMessage(res.message || 'Товар удалён из корзины');
            }
            fetchCart();
        } finally {
            setRemovingItemId(null);
        }
    };

    const handleOrder = async () => {
        if (isOrdering) {
            return;
        }

        setMessage('');
        setIsOrdering(true);

        try {
            const res = await createOrder(token);
            if (res.order_id) {
                setMessage(`Заказ #${res.order_id} успешно оформлен! Спасибо за покупку!`);
                setTimeout(() => {
                    navigate(`/order/${res.order_id}`);
                }, 1500);
            } else {
                setMessage(res.message || 'Не удалось оформить заказ');
                setIsOrdering(false);
            }
        } catch (error) {
            setMessage('Не удалось оформить заказ');
            setIsOrdering(false);
        }
    };

    const total = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                <div
                    style={{
                        background: '#ffffff',
                        borderRadius: '20px',
                        padding: '24px',
                        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
                        marginBottom: '20px'
                    }}
                >
                    <h2 style={{ margin: '0 0 8px 0', fontSize: '2rem', color: '#111827' }}>Моя корзина</h2>
                    <p style={{ margin: 0, color: '#6b7280' }}>
                        Проверьте выбранные товары перед оформлением заказа.
                    </p>
                </div>

                {message && (
                    <div
                        style={{
                            marginBottom: '1rem',
                            padding: '14px',
                            backgroundColor: '#ecfdf5',
                            border: '1px solid #a7f3d0',
                            borderRadius: '12px',
                            color: '#065f46'
                        }}
                    >
                        {message}
                    </div>
                )}

                {cartItems.length === 0 ? (
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '18px',
                            padding: '24px',
                            color: '#555',
                            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
                        }}
                    >
                        В корзине нет товаров
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {cartItems.map(ci => (
                            <div
                                data-id={"card-item"}
                                key={ci.item_id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '18px',
                                    padding: '16px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)'
                                }}
                            >
                                {ci.image_url && (
                                    <img
                                        src={ci.image_url}
                                        alt={ci.name}
                                        style={{
                                            width: '80px',
                                            height: '80px',
                                            objectFit: 'contain',
                                            borderRadius: '10px',
                                            background: '#f9fafb',
                                            padding: '8px'
                                        }}
                                    />
                                )}
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#111827' }}>
                                        {ci.name}
                                    </div>
                                    <div style={{ fontSize: '0.92rem', color: "#6b7280", marginTop: '6px' }}>
                                        Описание: {ci.description}
                                    </div>
                                    <div style={{ fontSize: '0.92rem', color: '#6b7280', marginTop: '4px' }}>
                                        Кол-во: {ci.quantity}
                                    </div>
                                    <div style={{ fontSize: '0.92rem', color: '#6b7280', marginTop: '4px' }}>
                                        Цена: {ci.price} руб. (шт)
                                    </div>
                                </div>
                                <button
                                    className="shop-btn-secondary"
                                    onClick={() => handleRemove(ci.item_id)}
                                    disabled={removingItemId === ci.item_id || isOrdering}
                                    style={{
                                        padding: '10px 14px',
                                        borderRadius: '10px',
                                        fontSize: '0.95rem'
                                    }}
                                >
                                    {removingItemId === ci.item_id ? 'Удаление...' : 'Удалить'}
                                </button>
                            </div>
                        ))}

                        <div
                            style={{
                                marginTop: '6px',
                                padding: '20px',
                                borderRadius: '18px',
                                background: '#ffffff',
                                boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
                            }}
                        >
                            <div style={{ fontSize: '1.15rem', marginBottom: '14px', color: '#111827' }}>
                                Итого: <strong>{total} руб.</strong>
                            </div>
                            <button
                                className="shop-btn-success"
                                onClick={handleOrder}
                                disabled={isOrdering}
                                style={{
                                    padding: '13px 22px',
                                    fontSize: '1rem',
                                    borderRadius: '12px'
                                }}
                            >
                                {isOrdering ? 'Оформление...' : 'Оформить заказ'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CartPage;